export default "__VITE_ASSET__BU$BHYkw__"